/* eslint-disable indent */
/* ====================================================================
   IMPORTS
   ==================================================================== */

/**
 * Dependency imports
 */

import createBehaviour from '../helpers/_createBehaviour';

/**
 * Behaviour imports
 */

/* ====================================================================
   BEHAVIOURS —> DROPDOWN
   ==================================================================== */

const handleCartForm = createBehaviour(
  /**
   * Register a name for the behaviour
   */

  'handleCartForm',
  {
    /**
     * All behaviour functions should be defined here and will be
     * accessible through 'this'
     *
     * Event listeners, intervals etc. will need to be registered
     * using the below lifecycle events
     */

    logInit() {
      console.log(`${this.name}: Initialised`);
    },
    logEnabled() {
      console.log(`${this.name}: Enabled`);
    },
    logResized() {
      console.log(`${this.name}: Resized`);
    },
    logDisabled() {
      console.log(`${this.name}: Disabled`);
    },
    logDestroyed() {
      console.log(`${this.name}: Destroyed`);
    },
  },
  {
    init() {
      /**
       * The behaviour has been initialised; event listeners,
       * variables etc. should be registered here
       *
       * All functions, variables etc. are accessible through `this`
       */

      /**
       * Expose the behaviour object for debugging
       */
      console.log(`${this.name}:`, this);

      const self = this;
      this.priceOutput = document.querySelector('#ProductPrice');

      this.selectForm = document.querySelector('#productSelect');
      console.log(this.selectForm);
    },
    enabled() {
      /**
       * The behaviour has been enabled; functions, variable overwrites
       * etc. can be called here
       * All functions, variables etc. are accessible through `this
       */
      const self = this;
      if (this.selectForm) {
        this.selectForm.onchange = function (event) {
          const { selectedIndex } = event.target;
          console.log(selectedIndex);
          const { price } = event.target.options[selectedIndex].dataset;

          console.log(`rc: ${price}`);

          self.priceOutput.innerText = price;
        };
      }
      // this.logEnabled();
    },
  },
);

export default handleCartForm;
